if ($('.type-detail').length) {
  $(document).ready(function () {
    function mhRemove() {
      $('.blogFeed .news-item').not(":nth-child(-n+3)").remove();
      $('.news-item').each(function () {
        $(this).find('img').attr('src', $(this).find('img').attr('data-src'))
        $(this).find('.description').after('<div class="text-right"><span class="name">Vojtěch Jiříček</span><a href="' + $(this).find('a.title').attr('href') + '">Celý článek</a></div>')
      });

    }
    if (sessionStorage.BlogFeed) {
      $('.blogFeed').append(sessionStorage.BlogFeed);
      $('.blogFeed').each(function () {
        const $carouselBlog = $(this);
        const $closestTitleBlog = $carouselBlog.prev('.homepage-group-title');
        $carouselBlog.slick({
          arrows: true,
          dots: false,
          infinite: false,
          speed: 300,
          appendArrows: $closestTitleBlog,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 992,
              settings: "unslick"
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2.1,
                slidesToScroll: 1,
                appendArrows: $closestTitleBlog,
              }


            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1,
                appendArrows: $closestTitleBlog,
              }
            }
          ]
        });
      });

    } else {
      $.ajax({
        type: "GET",
        dataType: "html",
        timeout: 1e4,
        cache: !0,
        url: "/cache/horeca-blog/",
        success: function (e) {
          var a = shoptet.common.createDocumentFromString(e),
            t = $(a).find("#newsWrapper").html();
          null !== t && ($(".blogFeed").html(t), mhRemove())

          sessionStorage.BlogFeed = $(".blogFeed").html();
        }
      })
        .done(function () {
          $('.blogFeed').each(function () {
            const $carouselBlog = $(this);
            const $closestTitleBlog = $carouselBlog.prev('.homepage-group-title');
            $carouselBlog.slick({
              arrows: true,
              dots: false,
              infinite: false,
              speed: 300,
              appendArrows: $closestTitleBlog,
              slidesToShow: 3,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 992,
                  settings: "unslick"
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                    appendArrows: $closestTitleBlog,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    appendArrows: $closestTitleBlog,
                  }
                }
              ]
            });
          });
        })
    }
  })

  $('.products').each(function () {
    const $carousel = $(this);
    const $closestTitleDetail = $carousel.prev('.products-related-header');
    $carousel.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: false,
      infinite: true,
      adaptiveHeight: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 991,
          settings: {
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2.2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1.9,
            slidesToScroll: 1,
            appendArrows: $closestTitleDetail
          }
        },
        {
          breakpoint: 330,
          settings: {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1.4,
            slidesToScroll: 1,
            appendArrows: $closestTitleDetail
          }
        }
      ]
    });
  });
  $('.basic-description h3').first().text('Popis produktu');
  $('.description-inner').prepend('<div class="dscImage"><div><img src="' + $('.p-image img').attr('src').replace('/big/', '/orig/') + '" alt="' + $('.p-image img').attr('alt') + '"></div></div>');
  $('.p-info-wrapper').append($('.p-detail-inner-header h1').clone(), $('.p-detail-inner-header .p-code').clone(), '<div class="customCart"></div>');
  $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'), $('.p-info-wrapper .availability-value'));
  if ($('.p[data-testid="productCardDescr"]').length) {
    var customDSC = $('.p-info-wrapper p[data-testid="productCardDescr"]').html()
  }
  else {
    var customDSC = ''
  }

  $('.customCart, .p-info-wrapper').append('<div class="bottom">' + customDSC + '</div>');
  document.addEventListener("dkLabFavouriteProductsLoaded", function () {
      $('.p-info-wrapper .bottom').prepend($('.add-to-cart+.dkLabFavouriteDiv'))
  });
  
  

  if ($('.p-info-wrapper p[data-testid="productCardDescr"]').length) {
    $('.bottom').append($('.p-info-wrapper p[data-testid="productCardDescr"]').find('a').text('Detail produktu'))
  }
  $('.p-code-label').text('Kód produktu:');

  $('.price-additional').each(function () {
    $(this).html(function () {
      return $(this).html().replace('včetně', 's')
    })
  })
  $('.price-additional').append('<span class="pr"> / ks</span>');
  $(".price-final-holder span").before(" <span class='without-vat'>bez DPH </span>");
  if($('.p-image-wrapper .flag-discount').length){
    $('.p-image').append(`
      <div class="customSale">
        <span class="topSale">
          zlevněno ${$('.p-image-wrapper .flag-discount .price-save').text()}
        </span>
        <span class="bottomSale">
          ${$('.p-image-wrapper .flag-discount .price-standard').text()} bez DPH / ks
        </span>
      </div>  
    `)
  }
};



if($('.type-detail').length){
  $(function () {
    let packagingCustomAmountTimeout = null;

    runPackagingProduct();
    setTimeout(syncPackagingFormsFromDataLayer, 100);

    [
        'ShoptetDOMPageContentLoaded',
        'ShoptetVariantAvailable'
    ].forEach(eventName => {
        document.addEventListener(eventName, function () {
            runPackagingProduct();
            setTimeout(syncPackagingFormsFromDataLayer, 100);
        });
    });

    [
        'ShoptetCartAddCartItem',
        'ShoptetCartUpdated',
        'ShoptetCartRemoveCartItem'
    ].forEach(eventName => {
        document.addEventListener(eventName, function () {
            setTimeout(syncPackagingFormsFromDataLayer, 500);
        });
    });

    function runPackagingProduct() {
        if (!$('body').hasClass('type-detail')) return;
        if ($('.packagingVariants').length) return;

        renderPackagingProduct();
    }

    function renderPackagingProduct() {
        const code = getCurrentProductCode();
        if (!code) return;

        const priceWithoutVat = getCurrentProductPriceWithVat();
        const priceWithVat = getCurrentProductPriceWithoutVat();
        const availability = getCurrentAvailability();

        const $target = $('.p-detail-inner .p-info-wrapper').length
            ? $('.p-detail-inner .p-info-wrapper')
            : $('.type-detail .p-detail-inner');

        if (!$target.length) return;

        const startPrice = formatCustomCurrency(0);

        const $box = $(`
            <div class="packagingVariants">
                <div class="packagingVariants__top">
                    <div>
                        <div class="packagingVariants__priceVat">
                            ${priceWithVat ? formatCustomCurrency(priceWithVat) + ' s DPH / ks' : ''}
                        </div>

                        <div class="packagingVariants__priceNoVat">
                            ${priceWithoutVat
                                ? '<strong>' + formatCustomCurrency(priceWithoutVat) + ' bez DPH</strong> <small>/ ks</small>'
                                : ''
                            }
                        </div>
                    </div>

                    <div class="packagingVariants__availability">
                        ${availability}
                    </div>
                </div>

                <div class="packagingVariants__items">
                    <div
                        class="packagingVariants__item"
                        data-var="ks"
                        data-package-type="pcs"
                        data-unit="ks"
                        data-unit-price="${escapeAttr(priceWithoutVat)}"
                        data-price="${escapeAttr(priceWithoutVat)}"
                        data-code="${escapeAttr(code)}"
                    >
                        <div class="packagingVariants__name">
                            <strong>1 ks</strong>
                        </div>

                        <div class="packagingVariants__unitPrice">
                            ${priceWithVat ? formatCustomCurrency(priceWithVat) : ''}
                            <span>/ ks</span>
                        </div>

                        <div class="packagingVariants__discount"></div>

                        <div class="packagingVariants__counter">
                            <form
                                action="${shoptet.config.updateCartUrl}"
                                method="post"
                                class="quantity-form js-quantity-form csrf-enabled customAmountForm"
                                data-code="${escapeAttr(code)}"
                                data-price-id=""
                                data-item-id=""
                                data-unit-price="${escapeAttr(priceWithoutVat)}"
                                data-default-price-id=""
                                data-current-amount="0"
                            >
                                <input type="hidden" name="itemId" value="">
                                <input type="hidden" name="priceId" value="">

                                <button type="button" class="amountMinus" aria-label="Snížit množství">−</button>

                                <div class="amountInputWrap">
                                    <input
                                        type="number"
                                        name="amount"
                                        class="amount amountInput"
                                        value="0"
                                        min="0"
                                        step="1"
                                        autocomplete="off"
                                        inputmode="numeric"
                                        data-decimals="0"
                                    >
                                    <span class="amountUnit">ks</span>
                                </div>

                                <button type="button" class="amountPlus" aria-label="Zvýšit množství">+</button>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="packagingVariants__bottom">
                    <div class="packagingVariants__code">
                        Kód produktu: <strong>${escapeHtml(code)}</strong>
                    </div>

                    <div class="packagingVariants__total">
                        Cena celkem: <strong>${startPrice}</strong>
                    </div>
                </div>
            </div>
        `);

        $target.append($box);
        $('.p-info-wrapper').addClass('hasPackagingVariants');

        bindPackagingEvents($box);
        syncPackagingFormsFromDataLayer();
    }

    function bindPackagingEvents($box) {
        $box.on('click', '.amountPlus', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $form = $(this).closest('.customAmountForm');
            const amount = parseInt($form.find('.amountInput').val(), 10) || 0;

            changePackagingAmount($form, amount + 1);
        });

        $box.on('click', '.amountMinus', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $form = $(this).closest('.customAmountForm');
            const amount = parseInt($form.find('.amountInput').val(), 10) || 0;

            if (amount <= 0) {
                $form.find('.amountInput').val(0);
                updatePackagingActiveState($form);
                return;
            }

            changePackagingAmount($form, amount - 1);
        });

        $box.on('input change', '.amountInput', function (e) {
            e.stopImmediatePropagation();

            const $input = $(this);
            const $form = $input.closest('.customAmountForm');

            let value = parseInt($input.val(), 10);

            if (isNaN(value) || value < 0) value = 0;

            $input.val(value);
            updatePackagingActiveState($form);

            clearTimeout(packagingCustomAmountTimeout);

            packagingCustomAmountTimeout = setTimeout(function () {
                changePackagingAmount($form, value);
            }, 500);
        });
    }

    function getCurrentProductCode() {
        if (typeof getShoptetDataLayer === 'function') {
            const product = getShoptetDataLayer('product');

            if (product) {
                if (product.code) return String(product.code).trim();
                if (product.productCode) return String(product.productCode).trim();
            }
        }

        let code = $('[data-micro="sku"]').first().text().trim();
        if (code) return code;

        code = $('.p-code, .product-code').first().text().trim();

        if (code) {
            return code
                .replace('Kód:', '')
                .replace('Kód produktu:', '')
                .trim();
        }

        return '';
    }

    function getCurrentProductPriceWithVat() {
        const selectors = [
            '.p-final-price-wrapper .price-final',
            '.price-final',
            '.p-detail-inner .price-final',
            '.p-info-wrapper .price-final'
        ];

        for (const selector of selectors) {
            const text = $(selector).first().text().trim();
            if (text) return parseCustomPrice(text);
        }

        return 0;
    }

    function getCurrentProductPriceWithoutVat() {
        const selectors = [
            '.price-additional',
            '.p-final-price-wrapper .price-additional',
            '.p-info-wrapper .price-additional'
        ];

        for (const selector of selectors) {
            const text = $(selector).first().text().trim();
            if (text) return parseCustomPrice(text);
        }

        /*
         * Pokud šablona cenu bez DPH samostatně nemá,
         * použije se cena, kterou najdeme jako hlavní.
         */
        return getCurrentProductPriceWithVat();
    }

    function getCurrentAvailability() {
        const $availability = $('.p-info-wrapper .availability-value, .p-detail-inner .availability-value').first();

        if ($availability.length) {
            return escapeHtml($availability.text().trim());
        }

        const text = $('.p-info-wrapper .availability, .p-detail-inner .availability')
            .first()
            .text()
            .trim();

        return text ? escapeHtml(text) : '';
    }

    function getCurrentCartItems() {
        if (typeof getShoptetDataLayer !== 'function') return [];

        const cart = getShoptetDataLayer('cart');
        return Array.isArray(cart) ? cart : [];
    }

    function syncPackagingFormsFromDataLayer() {
        syncPackagingFormsFromCartItems(getCurrentCartItems());
    }

    function syncPackagingFormsFromCartItems(cartItems) {
        if (!Array.isArray(cartItems)) return;

        $('.packagingVariants .customAmountForm').each(function () {
            const $form = $(this);
            const code = String($form.data('code') || '').trim();

            const cartItem = cartItems.find(item =>
                String(item.code || '').trim() === code
            );

            if (!cartItem) {
                $form.attr({
                    'data-item-id': '',
                    'data-price-id': '',
                    'data-current-amount': 0
                });

                $form.find('input[name="itemId"]').val('');
                $form.find('input[name="priceId"]').val('');
                $form.find('.amountInput').val(0);

                updatePackagingActiveState($form);
                return;
            }

            const quantity = parseInt(cartItem.quantity, 10) || 0;

            $form.attr({
                'data-item-id': cartItem.itemId || '',
                'data-price-id': cartItem.priceId || '',
                'data-current-amount': quantity
            });

            $form.find('input[name="itemId"]').val(cartItem.itemId || '');
            $form.find('input[name="priceId"]').val(cartItem.priceId || '');
            $form.find('.amountInput').val(quantity);

            updatePackagingActiveState($form);
        });

        updateAllPackagingTotals();
        updateAllPackagingHasActiveLine();
    }

    function changePackagingAmount($form, newAmount) {
        const code = String($form.data('code') || '').trim();

        const oldAmount = parseInt(
            $form.attr('data-current-amount'),
            10
        ) || 0;

        const itemId = String(
            $form.find('input[name="itemId"]').val() || ''
        ).trim();

        const priceId = String(
            $form.find('input[name="priceId"]').val() || ''
        ).trim();

        newAmount = parseInt(newAmount, 10);

        if (isNaN(newAmount) || newAmount < 0) {
            newAmount = 0;
        }

        if (newAmount === oldAmount) {
            $form.find('.amountInput').val(newAmount);
            updatePackagingActiveState($form);
            return;
        }

        $form.find('.amountInput').val(newAmount);
        $form.attr('data-current-amount', newAmount);

        updatePackagingActiveState($form);

        /*
         * Produkt ještě není v košíku.
         * Stačí productCode.
         */
        if (!itemId && newAmount > 0) {
            shoptet.cartShared.addToCart({
                productCode: code,
                amount: newAmount
            }, true);

            delayedPackagingSync(500);
            return;
        }

        if (!itemId && newAmount <= 0) {
            $form.attr('data-current-amount', 0);
            $form.find('.amountInput').val(0);

            updatePackagingActiveState($form);
            return;
        }

        /*
         * Poslední kus -> odstranit položku.
         */
        if (itemId && newAmount <= 0) {
            shoptet.cartShared.removeFromCart({
                itemId: itemId
            }, true);

            $form.attr({
                'data-item-id': '',
                'data-price-id': '',
                'data-current-amount': 0
            });

            $form.find('input[name="itemId"]').val('');
            $form.find('input[name="priceId"]').val('');
            $form.find('.amountInput').val(0);

            updatePackagingActiveState($form);
            delayedPackagingSync(500);

            return;
        }

        /*
         * U existující položky získáme priceId
         * ze Shoptet dataLayeru.
         */
        if (!priceId) {
            delayedPackagingSync(200);
            return;
        }

        submitPackagingAmountForm($form);
        delayedPackagingSync(500);
    }

    function submitPackagingAmountForm($form) {
        let displaySpinner = true;

        if (
            shoptet.abilities &&
            shoptet.abilities.feature &&
            !shoptet.abilities.feature.extended_ajax_cart &&
            $('body').hasClass('user-action-visible')
        ) {
            displaySpinner = false;
        }

        shoptet.cart.ajaxSubmitForm(
            shoptet.config.updateCartUrl,
            $form[0],
            'functionsForCart',
            'cart',
            displaySpinner
        );
    }

    function updatePackagingActiveState($form) {
        const amount = parseInt($form.find('.amountInput').val(), 10) || 0;
        const $item = $form.closest('.packagingVariants__item');
        const $box = $form.closest('.packagingVariants');

        $item.toggleClass('activeLine', amount > 0);
        $item.toggleClass('is-active', amount > 0);

        updatePackagingHasActiveLine($box);
        updatePackagingTotal($box);
    }

    function updatePackagingHasActiveLine($box) {
        if (!$box || !$box.length) return;

        $box.toggleClass(
            'hasActiveLine',
            $box.find('.packagingVariants__item.activeLine').length > 0
        );
    }

    function updateAllPackagingHasActiveLine() {
        $('.packagingVariants').each(function () {
            updatePackagingHasActiveLine($(this));
        });
    }

    function updatePackagingTotal($box) {
        if (!$box || !$box.length) return;

        let total = 0;

        $box.find('.customAmountForm').each(function () {
            const $form = $(this);
            const amount = parseInt($form.find('.amountInput').val(), 10) || 0;
            const unitPrice = parseCustomPrice($form.attr('data-unit-price'));

            total += amount * unitPrice;
        });

        $box.find('.packagingVariants__total strong')
            .text(formatCustomCurrency(total));
    }

    function updateAllPackagingTotals() {
        $('.packagingVariants').each(function () {
            updatePackagingTotal($(this));
        });
    }

    function delayedPackagingSync(delay = 500) {
        setTimeout(syncPackagingFormsFromDataLayer, delay);
    }

    function parseCustomPrice(value) {
        if (typeof value === 'number') return value;
        if (!value) return 0;

        let text = String(value)
            .replace(/\u00a0/g, '')
            .replace(/\s/g, '')
            .replace(/Kč/gi, '')
            .replace(/CZK/gi, '')
            .replace(',', '.');

        /*
         * Když je v textu např. "1 200 Kč s DPH",
         * vytáhneme první číselnou hodnotu.
         */
        const match = text.match(/\d+(?:\.\d+)?/);

        return match ? Number(match[0]) || 0 : 0;
    }

    function formatCustomCurrency(value) {
        value = Number(value) || 0;

        if (typeof value.ShoptetFormatAsCurrency === 'function') {
            return value.ShoptetFormatAsCurrency();
        }

        return value.toLocaleString('cs-CZ') + ' Kč';
    }

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function escapeAttr(value) {
        return escapeHtml(value);
    }
});
}